import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { ReportImportService } from 'src/app/services/report-import/report-import.service';
import { IDataAnalyseResult, ReportSelectionImportMode } from 'src/app/services/report-import/utils';

export interface IReportSelectorPopupInput {
  mode: ReportSelectionImportMode;
  file: File;
}

export type IReportSelectorPopupOuput = string[];

export interface I_Month_Data {
  date: Date;
  value: string;
  missingColums?: string[];
}

export interface I_Year_Data {
  value: string;
  missingColums?: string[];
}

@Component({
  selector: 'app-report-selector',
  templateUrl: './report-selector.component.html',
  styleUrls: ['./report-selector.component.scss']
})
export class ReportSelectorComponent implements OnInit {
  public selectionMode: ReportSelectionImportMode;

  @ViewChild('monthsSelectionList') monthsSelectionList: MatSelectionList;
  @ViewChild('yearsSelectionList') yearsSelectionList: MatSelectionList;

  public monthsData: I_Month_Data[];
  public yearsData: I_Year_Data[];

  public selectedSheetsNames: string[];
  public selectedYears: string[];

  public rentReportsImportInfo: IDataAnalyseResult;
  public galleriesImportInfo: IDataAnalyseResult;

  public hasErrors: boolean = false;
  public loaded: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public defaults: IReportSelectorPopupInput,
    private dialogRef: MatDialogRef<ReportSelectorComponent, IReportSelectorPopupOuput>,
    private service: ReportImportService
  ) {}

  public ngOnInit(): void {
    this.selectionMode = this.defaults.mode;

    switch (this.selectionMode) {
      case ReportSelectionImportMode.MONTHLY:
        void this.processMonth();
        break;

      case ReportSelectionImportMode.YEARLY:
        void this.processYear();
        break;

      case ReportSelectionImportMode.LOCATION:
        void this.processLocation();
        break;

      case ReportSelectionImportMode.GALLERY:
        void this.processGallery();
        break;
    }
  }

  private processGallery(): Promise<void> {
    return this.service.analyseGalleryReportData(this.defaults.file).then((result) => {
      this.galleriesImportInfo = result;

      if (result.missingColumns.length > 0) this.hasErrors = true;

      this.loaded = true;
    });
  }

  private processLocation(): Promise<void> {
    return this.service.analyseLocationReportData(this.defaults.file).then((result) => {
      this.rentReportsImportInfo = result;

      if (result.missingColumns.length > 0) this.hasErrors = true;

      this.loaded = true;
    });
  }

  public processMonth(): Promise<void> {
    return this.service.analyseMonthlyReportData(this.defaults.file).then((result) => {
      this.monthsData = result.map((sheet) => {
        const monthYear = sheet.name;
        const year = parseInt(monthYear.substring(0, 4));
        const month = parseInt(monthYear.substring(4, 6));

        const date: Date = new Date();

        date.setFullYear(year, month - 1);

        return { date: date, value: monthYear, missingColums: sheet.missingColums };
      });

      this.loaded = true;
    });
  }

  public processYear(): Promise<void> {
    return this.service.analyseYearReportData(this.defaults.file).then((result) => {
      this.yearsData = result.map((sheet) => {
        return { value: sheet.name, missingColums: sheet.missingColums };
      });

      this.loaded = true;
    });
  }

  public onSelection(): void {
    switch (this.selectionMode) {
      case ReportSelectionImportMode.MONTHLY:
        this.selectedSheetsNames = this.monthsSelectionList.selectedOptions.selected.map((s) => s.value as string);

        break;
      case ReportSelectionImportMode.YEARLY:
        this.selectedYears = this.yearsSelectionList.selectedOptions.selected.map((s) => s.value as string);
        break;
    }
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  public validate(): void {
    switch (this.selectionMode) {
      case ReportSelectionImportMode.MONTHLY:
        this.dialogRef.close(this.selectedSheetsNames);
        break;
      case ReportSelectionImportMode.YEARLY:
        this.dialogRef.close(this.selectedYears);
        break;
      case ReportSelectionImportMode.LOCATION:
        this.dialogRef.close(this.rentReportsImportInfo.toCreate);
        break;
      case ReportSelectionImportMode.GALLERY:
        this.dialogRef.close(this.galleriesImportInfo.toCreate);
        break;
    }
  }
}
